// removed by extract-text-webpack-plugin
module.exports = {"inputPriceWrap":"qempo_InputPrice_inputPriceWrap-3SakZfI","currency":"qempo_InputPrice_currency-3f-E_xT","red":"qempo_InputPrice_red-P4QDCky","yellow":"qempo_InputPrice_yellow-1ppnFC_","filled":"qempo_InputPrice_filled-LU5hQQ4","price":"qempo_InputPrice_price-3RKlKXs"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/InputPrice/InputPrice.scss
// module id = 1633
// module chunks = 0